import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';

import FormLabel from 'components/FormLabel/FormLabel';
import FormInput from 'components/FormInput/FormInput'
import FormSelection from 'components/FormSelection/FormSelection'

const FormPhoneNumber = ({ form, countryPhoneCodeSelections, defaultValues }) => {
  return (
    <>
      <FormLabel size="large" hasRequiredErrorMessage style={{ marginBottom: 0 }}>
        Contact Number
      </FormLabel>
      <Row type="flex">
        <Col span={6}>
          <FormSelection
            form={form}
            name="contactCountryCode"
            size="large"
            defaultValue={defaultValues.contactCountryCode}
            selections={countryPhoneCodeSelections}
            requiredErrorMessage="Please select a country code"
          />
        </Col>
        <Col span={18}>
          <FormInput
            form={form}
            name="contactNumber"
            placeholder="0122211333"
            size="large"
            defaultValue={defaultValues.contactNumber}
            autoComplete="new-contact"
            requiredErrorMessage="Please enter your contact number."
            extraRules={[
              {
                pattern: '^[+0-9][-s0-9]*$',
                message: 'Please enter a valid contact number.'
              }
            ]}
          />
        </Col>
      </Row>
    </>
  );
};

FormPhoneNumber.propTypes = {
  form: PropTypes.object.isRequired,
  countryPhoneCodeSelections: PropTypes.array.isRequired,
  defaultValues: PropTypes.object,
};

FormPhoneNumber.defaultProps = {
  defaultValues: {},
};

export default FormPhoneNumber;
